import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { GlobalcfgService } from 'src/service/globalcfg.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
@HostListener('window:resize', ['$event'])
export class SideNavComponent implements OnInit {
  _opened = false;
  username:any;
  width: number = window.innerWidth;
  slideType = 'slide';
  mobileDevice = true;
  imageSource: string;
  receiverMenu:any= {
    name: 'Verifier',
    path: '/challan-list',
    isSelected: true,
    height:170,
    
    dropDown: [ {
        name: 'Verify Containers',
        isSelected: true,
        path: '/challan-list'
      }
      // , {
      //   name: 'Onboard Container',
      //   isSelected: false,
      //   path: '/onboard-container'
      // }
    ]
  };



  importInMenu:any= {
    name: 'Import Incharge',
    path: '/importincharge',
    isSelected:true,
    height:50,
    dropDown: [
      {
        name: 'Receive Container',
        path: '/importincharge',
        isSelected: true,
      },
      {
        name: 'Allocate number of Containes',
        path: '/importincharge/allocate-containers',
        isSelected: false,
      }
      ,
      // {
      //   name: 'Issue Container for Sampling',
      //   path: '/importincharge/issue-container-for-sampling',
      //   isSelected: false,
      // },
      {
        name: 'Send Samples to Lab',
        path: '/importincharge/send-samples-to-lab',
        isSelected: false,
      }
    ]
  };



  assImportIncharge:any= {
    name: 'Ass Import Incharge',
    path: '/ass-Import-Incharge',
    isSelected:true,
    height:50,
    dropDown: [
      {
        name: 'Validate Containers',
        path: '/ass-Import-Incharge',
        isSelected: true,
      },
      {
        name: 'Exit Containers',
        path: '/ass-Import-Incharge/exit-containers',
        isSelected: false,
      },
      {
        name: 'Container Information',
        path: '/ass-Import-Incharge/container-confimation',
        isSelected: false,
      }
      
    ]
  };



  labReceiver:any= {
    name: 'Lab Receiver',
    path: '/lab-receiver',
    isSelected:true,
    height:50,
    dropDown: [
      {
        name: 'Receive Sample',
        path: '/lab-receiver',
        isSelected: true,
      }
    ]
  };

  labAdmin:any= {
    name: 'Lab Admin',
    path: '/lab-admin',
    isSelected:true,
    height:50,
    dropDown: [
      {
        name: 'Received Samples',
        path: '/lab-admin',
        isSelected: true,
      },{
        name: 'Approve Results',
        path: '/lab-admin/approve-results',
        isSelected: false,
      },
      {
        name: 'Print Results',
        path: '/lab-admin/print-results',
        isSelected: false,
      }
    ]
  };









  adminMenu:any= {
    name: 'Super Admin',
    path: 'Invite User',
    isSelected:true,
    height:50,
    dropDown: [
      {
        name: 'Dashboard',
        path: '/super-admin/dashboard',

        isSelected: false,
        navigate: true
      },
      {
        name: 'Reports',
        path: '/super-admin/reports',
        isSelected: false,
        navigate: true
      },
      {
        name: 'User Logs',
        path: '/super-admin/user-logs',
        isSelected: false,
        navigate: true
      },
      {
        name: 'Add Users',
        path: '/super-admin/add-user',

        isSelected: true,
        navigate: true
      }
      ,
      {
        name: 'Select No. of Containers to be Sampled',
        path: '/super-admin/challan-for-sampling',

        isSelected: false,
        navigate: true
      },
      {
        name: 'Publish Results',
        path: '/super-admin/publish-results',
        isSelected: false,
        navigate: true
      },
      {
        name: 'Master Data',
        path: '/super-admin/master-data',
        isSelected: false,
        navigate: true
      },
      {
        name: 'Traceability Reports',
        path: '/super-admin/traceability-reports',
        isSelected: false,
        navigate: true
      }
    ]
  };
  sampleAssistant:any= {
    name: 'Sample Assistant',
    path: '/sample-assistant',
    isSelected:true,
    height:50,
    dropDown: [
      {
        name: 'Create Sample',
        path: '/sample-assistant/',
        isSelected: true,
      }
    ]
  };

  labAce:any= {
    name: 'Lab Ace',
    path: '/lab-ace',
    isSelected:true,
    height:50,
    dropDown: [
      {
        name: 'Review Samples',
        path: '/lab-ace',
        isSelected: true,
      }
    ]
  };
  

  labAnalyst:any= {
    name: 'Lab Analyst',
    path: '/lab-analyst',
    isSelected:true,
    height:50,
    dropDown: [
      {
        name: 'Samples Pending',
        path: '/lab-analyst',
        isSelected: true,
      }
    ]
  };
  





  dataEntryMenu:any= {
    name: 'Data Entry Operator',
    path: '/data-entry-challan-list',
    isSelected: true,
    height:170,
    
    dropDown: [
      {
        name: 'Create Challan',
        path: '/data-entry-challan-list',
        isSelected: true,
      }
    ]
  }
  
  menuPages = [];
  location: string;
  
  constructor(
    private router: Router,private authGuard:AuthGuard,
    private globalcfgService:GlobalcfgService) {
  

      this.menuPages=[];
      let roleID=localStorage.getItem('roleName');
      
      this.username=localStorage.getItem('username');
      this.location = localStorage.getItem('location');
      if(roleID){
        const isRole:any = true;
         localStorage.setItem('isRole' , isRole);


      }
      if(roleID === 'VERIFIER' ){
        this.authGuard.checkIdStatus();
        this.menuPages.push(this.receiverMenu);
      } else if(roleID === 'DATA ENTRY OPERATOR'){
        this.authGuard.checkIdStatus();
        this.menuPages.push(this.dataEntryMenu);
      }else if(roleID === 'IMPORT IN-CHARGE'){
        this.authGuard.checkIdStatus();
        this.menuPages.push(this.importInMenu);
      } 
      else if(roleID === 'SAMPLE ASSISTANT'){
        this.authGuard.checkIdStatus();
        this.menuPages.push(this.sampleAssistant);

      } 
      else if(roleID === 'LAB RECEIVER'){
        this.authGuard.checkIdStatus();

        this.menuPages.push(this.labReceiver);
      } 
      else if(roleID === 'LAB ADMIN'){
        this.authGuard.checkIdStatus();

        this.menuPages.push(this.labAdmin);
      } 
      else if(roleID === 'LAB ANALYST'){
        this.authGuard.checkIdStatus();
        this.menuPages.push(this.labAnalyst);
      }  else if(roleID === 'LAB ACE'){
        this.authGuard.checkIdStatus();

        this.menuPages.push(this.labAce)

      }else if(roleID === 'ASSISTANT IMPORT IN-CHARGE'){
        this.authGuard.checkIdStatus();

        this.menuPages.push(this.assImportIncharge)

      }
      else{
        if(roleID === 'SUPER ADMIN'){
          this.authGuard.checkIdStatus();
        this.menuPages.push(this.adminMenu);
        }
      }
      
     }

  ngOnInit(): void {
    if (this.width > 768) {
      this.slideType = 'push';
      this.mobileDevice = false;
      this._opened = true;
    }
  }

  _toggleSidebar() {
    this._opened = !this._opened;
  }

  getClick(page) {
    
    this.menuPages.forEach(li => {
      if (li === page) {
        li.isSelected = true;
        this.router.navigate([li.path])
      } else {
        li.isSelected = false;
      }
    });
  }
  changeBackground(child,parent){
    
    this.menuPages.forEach(li => {
      if (li === parent) {
        li.dropDown.forEach(childLi => {
          if (childLi === child) {
            childLi.isSelected = true
          } else{
            childLi.isSelected = false;

          }
          });
      } else {
        li.isSelected = false;
      }
    });
  }
  logout() {
    localStorage.clear();
    this.router.navigate(['sign-in']);
  }
  goToCreateScreener(name) {
  }
}
